module.exports = __webpack_public_path__ + "img/custom.c39f738a.svg";